"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var TypeStyle = require("typestyle");
var ClickBusting_1 = require("../../config/ClickBusting");
var Localize_1 = require("../../../gen-src/Localize");
var Icons_1 = require("../../icons/Icons");
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var ChipStyleName = TypeStyle.style(PreventUserSelect_1.PreventUserSelect, {
    alignItems: 'center',
    backgroundColor: '#ebebeb',
    border: "1px solid #d4d4d4",
    borderRadius: 1,
    boxSizing: 'border-box',
    color: '#333',
    display: 'inline-flex',
    fontFamily: 'inherit',
    fontSize: TabStyles_1.TabStyles.Typography.Sizing.Default,
    lineHeight: 'inherit',
    overflow: 'hidden',
    padding: '0 3px',
    position: 'relative',
    transition: 'border-color 75ms',
    $nest: {
        '&:hover': { backgroundColor: '#f5f5f5' },
        '&[aria-selected="true"]': { backgroundColor: '#cccccc' },
        '&:focus': {
            borderColor: TabStyles_1.TabStyles.Colors.Focus,
            boxShadow: 'none !important',
            outline: 'none',
        },
        '&:active': { backgroundColor: '#d4d4d4' },
        '&[aria-disabled="true"]': { backgroundColor: '#f5f5f5', color: '#bfbfbf' },
        '&[aria-busy="true"]::after': {
            backgroundColor: 'rgba(255,255,255,0.6)',
            bottom: 0,
            content: "\"\"",
            left: 0,
            pointerEvents: 'none',
            position: 'absolute',
            right: 0,
            top: 0,
        }
    }
});
// tslint:disable:max-line-length
var RemoveChipIcon = function (fill) {
    if (fill === void 0) { fill = '#666'; }
    return "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"8\">\n<path fill=\"" + fill + "\" d=\"M4.78873239 4L7.83098592.95774648c.22535211-.22535211.22535211-.56338028 0-.7887324-.22535212-.2253521-.56338029-.2253521-.7887324 0L4 3.21126762.95774648.16901408c-.22535211-.2253521-.56338028-.2253521-.7887324 0-.2253521.22535212-.2253521.56338029 0 .7887324L3.21126762 4 .16901408 7.04225352c-.2253521.22535211-.2253521.56338028 0 .7887324.22535212.22535211.56338029.22535211.7887324 0L4 4.78873239l3.04225352 3.04225353c.22535211.22535211.56338028.22535211.7887324 0 .22535211-.22535212.22535211-.56338029 0-.7887324L4.78873239 4z\"/>\n</svg>";
};
// tslint:enable:max-line-length
var RemoveButtonStyleName = TypeStyle.style({
    background: "center no-repeat url(" + Icons_1.encodeSvg(RemoveChipIcon()) + ")",
    boxSizing: 'border-box',
    flexShrink: 0,
    height: 22,
    marginLeft: 5,
    marginRight: -3,
    width: 22,
    $nest: {
        '&:hover': { backgroundImage: "url(" + Icons_1.encodeSvg(RemoveChipIcon('#333')) + ")" },
        '&:active': { backgroundImage: "url(" + Icons_1.encodeSvg(RemoveChipIcon('#333')) + ")" }
    }
});
var RemoveButton = function (props) { return React.createElement("div", { "aria-hidden": true, className: RemoveButtonStyleName, "data-tb-test-id": 'remove-Button', onClick: props.onRemove && (function (e) { props.onRemove(); e.stopPropagation(); }), role: 'button', title: Localize_1.Messages.remove() }); };
exports.Chip = React.forwardRef(function (props, ref) {
    var className = props.className, children = props.children, onRemove = props.onRemove, testId = props.testId, tooltip = props.tooltip, value = props.value, htmlProps = tslib_1.__rest(props, ["className", "children", "onRemove", "testId", "tooltip", "value"]);
    return (React.createElement("div", tslib_1.__assign({ "data-tb-test-id": Declarative_1.testId(testId, 'Chip'), ref: ref, title: tooltip }, htmlProps, { className: TypeStyle.classes(ChipStyleName, ClickBusting_1.ClickBustingConfig.suppressionClassName, className) }),
        children,
        onRemove && React.createElement(RemoveButton, { onRemove: onRemove })));
});
exports.Chip.displayName = 'Chip';
//# sourceMappingURL=Chip.js.map